import { render } from "./AboutView.vue?vue&type=template&id=7f970849"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=7f970849&lang=css"

import exportComponent from "/Volumes/Projects/wp_lab/wp-content/plugins/debug-log-config-tool-x/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/views/AboutView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f970849"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f970849', __exports__)) {
    console.log('reload')
    api.reload('7f970849', __exports__)
  }
  
  module.hot.accept("./AboutView.vue?vue&type=template&id=7f970849", () => {
    console.log('re-render')
    api.rerender('7f970849', render)
  })

}


export default __exports__